import { Heart } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_9013cffc-5815-4696-af30-6ef829e3ad5d/artifacts/390zcaea_logo.png";

export default function Footer() {
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <footer data-testid="footer" className="bg-[#0d1b2e] border-t border-[#d4af37]/10 py-16 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="SitarMusic" className="h-10 w-auto" />
              <span className="font-['Cormorant_Garamond'] text-xl text-[#d4af37]">SitarMusic</span>
            </div>
            <p className="text-[#a3b1c6] text-sm leading-relaxed">
              The definitive destination for sitar music lovers worldwide. Preserving tradition, embracing innovation.
            </p>
          </div>

          <div>
            <h4 className="text-[#d4af37] text-sm uppercase tracking-wider mb-4 font-medium">Explore</h4>
            <ul className="space-y-2">
              {[['History', 'history'], ['Artists', 'artists'], ['Genres', 'genres'], ['Media', 'media']].map(([label, id]) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="text-[#a3b1c6] hover:text-[#d4af37] text-sm transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#d4af37] text-sm uppercase tracking-wider mb-4 font-medium">Connect</h4>
            <ul className="space-y-2">
              {[['Events', 'events'], ['Resources', 'resources'], ['Contact', 'contact']].map(([label, id]) => (
                <li key={id}>
                  <button onClick={() => scrollTo(id)} className="text-[#a3b1c6] hover:text-[#d4af37] text-sm transition-colors">
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[#d4af37] text-sm uppercase tracking-wider mb-4 font-medium">Legal</h4>
            <ul className="space-y-2 text-[#a3b1c6] text-sm">
              <li>Privacy Policy</li>
              <li>Terms of Service</li>
              <li>Cookie Policy</li>
            </ul>
          </div>
        </div>

        <div className="section-divider mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-[#a3b1c6] text-sm">
          <p>&copy; {new Date().getFullYear()} SitarMusic.com. All rights reserved.</p>
          <p className="flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-[#d4af37] fill-[#d4af37]" /> for the love of music
          </p>
        </div>
      </div>
    </footer>
  );
}
